import { app } from '../../../../app';

app.factory('EmailVerificationDataService', EmailVerificationDataService);

/** @ngInject */
function EmailVerificationDataService($resource) {
    return $resource('app/rest/emailverificationdata', {}, {});
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/email/email-verification.service.js